import { put, call, all } from "redux-saga/effects";
import {
  getReportCardDeatils,
  getHandInfoList,
  getStarDetails,
  getPromotionalContent,
  getMedalDeatils,
  getMissions,
  getMyStatistics,
  getPlayerLevelsSaga,
  getPlayerGameSubTypesSaga,
  getPlayerHitTypesSaga
} from "../../endPoints/multipleReportCards";
import moment from "moment";
import * as actions from "../actions/index";
import * as selectors from "../selectors";
import { select } from "redux-saga/effects";
import { saveActivity } from "../../common/commonService"

export function* setReportSettingData(response) {
  try {
    let {
      gameType,
      accountName,
      fromDate,
      fromTime,
      toDate,
      toTime,
      shift,
      hitLevel,
      hitType,
      hitRange,
      userRole,
      userType
    } = response;
    userType = localStorage.getItem("loggedInType");
    if (hitRange != "Select") {
      let playerReportCard = yield select(selectors.playerReportCard),
        // value = Object.keys(playerReportCard.rangeList.filter(range => Object.values(range)[0] === hitRange)[0])[0]
        value = Object.keys(
          playerReportCard.rangeList.filter(
            range => Object.keys(range).map(e => range[e])[0] === hitRange
          )[0]
        )[0];
      if (value != "day") {
        if (value === "All Time")
          fromDate = moment("1970-01-01").utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        else
          fromDate = moment()
            .subtract(
              value.match(/^(\S+)\s(.*)/).slice(1)[0],
              value.match(/^(\S+)\s(.*)/).slice(1)[1]
            )
            .startOf(value.match(/^(\S+)\s(.*)/).slice(1)[1])
            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        if (value == "7 days" || value == "1 days")
          toDate = moment()
            .subtract(1, value.match(/^(\S+)\s(.*)/).slice(1)[1])
            .endOf(value.match(/^(\S+)\s(.*)/).slice(1)[1])
            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        else
          toDate = moment()
            .subtract(
              value.match(/^(\S+)\s(.*)/).slice(1)[0],
              value.match(/^(\S+)\s(.*)/).slice(1)[1]
            )
            .endOf(value.match(/^(\S+)\s(.*)/).slice(1)[1])
            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      }
    }
    let reportSetting = {
      gameType,
      accountName,
      fromDate,
      fromTime,
      toDate,
      toTime,
      shift,
      hitLevel,
      hitType,
      hitRange,
      userRole,
      userType
    };
    if (response.hands < 100) reportSetting.notEnoughHands = true;
    return reportSetting;
  } catch (error) {
    throw new Error(error);
  }
}

// let saveActivity = activityObj => {
//   let activityTrack = [];
//   let track = {};
//   if (localStorage.getItem("activityTrack"))
//     activityTrack = JSON.parse(localStorage.getItem("activityTrack"));
//   (track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')),
//     (track.session_id = localStorage.getItem("token"));
//   track.userid = localStorage.getItem("username");
//   track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"));
//   track.hit_page = activityObj.hit_page;
//   track.hit_type = activityObj.hit_type;
//   track.hit_attribute1 = activityObj.hit_attribute1
//     ? activityObj.hit_attribute1
//     : "";
//   track.hit_attribute2 = activityObj.hit_attribute2
//     ? activityObj.hit_attribute2
//     : "";
//   track.hit_attribute3 = activityObj.hit_attribute3
//     ? activityObj.hit_attribute3
//     : "";
//   track.hit_attribute4 = activityObj.hit_attribute4
//     ? activityObj.hit_attribute4
//     : "";
//   track.hit_attribute5 = activityObj.hit_attribute5
//     ? activityObj.hit_attribute5
//     : "";
//   track.hit_attribute6 = activityObj.hit_attribute6
//     ? activityObj.hit_attribute6
//     : "";
//   activityTrack.push(track);
//   localStorage.setItem("activityTrack", JSON.stringify(activityTrack));
// };

export function* getMultiReportCardDeatilsSaga(action) {
  try {
    let accountName = "";
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    let reportCardData = [];
    action.data.map(reportDtls => {
      accountName = reportDtls.accountName;
      let SB = "All";
      let BB = "All";
      reportDtls["language"] = localStorage.getItem("new_language") || "en";
      if (reportDtls.hitRange === "Today") {
        if (reportDtls.hitLevel && reportDtls.hitLevel !== "All Level") {
          [SB, BB] = reportDtls.hitLevel.split("/");
        }
        if (reportDtls.fromDate === undefined) {
          reportDtls.fromDate = moment() .startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
          reportDtls.toDate = moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        }
      }
      let gameDateInfo = moment().format("DD/MM/YYYY");
    
      if (reportDtls.hitRange === "Today")
        reportCardData.push(
          call(getReportCardDeatils,
            {
              ...reportDtls,
              key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${reportDtls.gameType}:${reportDtls.hitType}:${SB}:${BB}`
            })
        );
      else
        reportCardData.push(call(getReportCardDeatils, {...reportDtls,SB,BB,gameSubType: "NLH"}));
    });
    const [response1, response2, response3, response4] = yield all(reportCardData);
    const [repoSetting1, repoSetting2, repoSetting3, repoSetting4] = yield all([
      setReportSettingData(response1.data),
      setReportSettingData(response2.data),
      setReportSettingData(response3.data),
      setReportSettingData(response4.data)

    ]);
    saveActivity({
      hit_page: "SkillLevelPage",
      hit_type: "SkillLevelPage",
      hit_attribute1: 
        response1.data.hands >= 100
          ? response1.data.gameType+"--"+response1.data.summaryInfo[0].medal
          : response1.data.gameType+"--"+"No Report",
      hit_attribute2:
      response2.data.hands >= 100
        ? response2.data.gameType+"--"+response2.data.summaryInfo[0].medal
        : response2.data.gameType+"--"+"No Report",
      hit_attribute3:
      response3.data.hands >= 100
        ? response3.data.gameType+'--'+response3.data.summaryInfo[0].medal
        : response3.data.gameType+'--'+"No Report",
      hit_attribute4:
      response4.data.hands >= 100
        ? response4.data.gameType+'--'+response4.data.summaryInfo[0].medal
        : response4.data.gameType+'--'+"No Report",
    });

    let gameNumbers = [];
    [response1, response2, response3, response4].map(response => {
      if (response.data && response.data.topHands) {
        response.data.topHands.topWonHands.map(hand => {
          gameNumbers.push(hand.gameNo)
        })
        response.data.topHands.topLostHands.map(hand => {
          gameNumbers.push(hand.gameNo)
        })
        }
      })
      let handInfoList = {}
      if(gameNumbers.length > 0) {
        handInfoList = yield call(getHandInfoList, {
          accountName: localStorage.getItem("accountName"),
          gameNumbers
        })
      }
      // set star status
      [response1, response2, response3, response4].map(response => {
        if(response.data && response.data.topHands) {
          if (handInfoList.data && handInfoList.data.length > 0) {
            response.data.topHands.topWonHands = response.data.topHands.topWonHands.map(hand => {
              hand.staredHand = false;
              handInfoList.data.map(handInfo => {
                if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
                  hand.staredHand = handInfo.staredHand;
                  }
                })
                return hand;
              })
              response.data.topHands.topLostHands = response.data.topHands.topLostHands.map(hand => {
                hand.staredHand = false;
                handInfoList.data.map(handInfo => {
                  if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
                    hand.staredHand = handInfo.staredHand;
                  }
                })
                return hand;
              })
            }
        }
      })
        
    yield all([
      put(
        actions.setMultiReportCardDeatils([
          response1.data,
          response2.data,
          response3.data,
          response4.data
        ])
      ),
      put(
        actions.setReportCardSetting([repoSetting1, repoSetting2, repoSetting3, repoSetting4])
      ),
      put(actions.setLoading({ loading: false, isPromotional: false }))
    ]);
  } catch (err) {
    console.log(err);
    yield put(actions.setLoading({ loading: false, isPromotional: false }));
    throw new Error(err);
  }
}

// export function* getMultiReportCardDeatilsSaga(action) {
//     try {
//         let accountName = ''
//         yield put(actions.setLoading(true))
//         let reportCardData = []
//         action.data.map((reportDtls) => {
//             accountName = reportDtls.accountName
//             if (reportDtls.gameType != 'tournament') {
//                 reportCardData.push(call(getReportCardDeatils, reportDtls))
//             }
//         })
//         const [response1] = yield all(reportCardData)

//         const [repoSetting1, repoSetting2] = yield all([
//             setReportSettingData(response1.data),
//             setReportSettingData({
//                 hitRange: 'Select',
//                 gameType: 'tournament',
//                 hitLevel: 'All Level',
//                 hitType: 'Full Ring',
//                 accountName: '',
//             })
//         ])
//         let response2 = { gameType: 'tournament', hands: 0, summaryInfo: [{ points: 0 }] }
//         saveActivity({
//             hit_page: 'SkillLevelPage',
//             hit_type: 'SkillLevelPage',
//             hit_attribute1:  response1.data.hands >= 100 ? response1.data.summaryInfo[0].medal : 'No Report',
//             hit_attribute2: typeof response1.data.star === 'undefined' ?  response1.data.hands.toString() : response1.data.star,
//             hit_attribute3:  response2.hands >= 100 ? response2.summaryInfo[0].medal : 'No Report',
//             hit_attribute4: typeof response2.star === 'undefined' ?  response2.hands.toString() : response2.star,
//             hit_attribute6: accountName,
//         })
//         yield all([
//             put(actions.setMultiReportCardDeatils([response1.data, response2])),
//             put(actions.setReportCardSetting([repoSetting1, repoSetting2])),
//             put(actions.setLoading(false))
//         ])
//     } catch (err) {
//         yield put(actions.setLoading(false))
//         throw new Error(err)
//     }
// }

export function* getOnLoadReportCardDtlsSaga(action) {
  try {
    let playerReportCard = yield select(selectors.playerReportCard);
    const [repoSetting1, repoSetting2, repoSetting3, repoSetting4] = yield all([
      setReportSettingData(action.data),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != action.data.gameType)[0]),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != action.data.gameType)[1]),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != action.data.gameType)[2])
    ]);
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    let SB = "All";
    let BB = "All";
    if (repoSetting1.hitRange === "Today") {
      if (repoSetting1.hitLevel && repoSetting1.hitLevel !== "All Level") {
        [SB, BB] = repoSetting1.hitLevel.split("/");
      }
    }
    let gameDateInfo = moment().format("DD/MM/YYYY");
    repoSetting1["language"] = localStorage.getItem("new_language") || "en";
    const [response, response1, response2] = yield all([
      action.data.hitRange === "Select" || !action.data.playerStats
        ? call(getReportCardDeatils, {
          ...repoSetting1,
          key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${
            repoSetting1.gameType
            }:${repoSetting1.hitType}:${SB}:${BB}`
        })
        : {},
      call(getMedalDeatils, { gameType: action.data.gameType }),
      call(getStarDetails, { gameType: action.data.gameType })
      // ,localStorage.getItem("userRole").indexOf("PLAYER") != -1 && localStorage.getItem("accountName") === action.data.accountName ? call(getMissions, repoSetting1) : { data: {} }
    ]);

    let plyReport = Object.keys(response).length > 0 ? response : action;
    saveActivity({
      hit_page: `${action.data.gameType}ReportCard`,
      hit_type: "ReportCardDisplay",
      hit_attribute1:
        plyReport.data.hitRange === "Select"
          ? "PlayerDetails:" + plyReport.data.hands
          : plyReport.data.hitRange,
      hit_attribute2: plyReport.data.hitType,
      hit_attribute3: plyReport.data.hitLevel,
      hit_attribute4: plyReport.data.summaryInfo[0].medal
        ? plyReport.data.summaryInfo[0].medal
        : "",
      hit_attribute5: plyReport.data.summaryInfo[0].playerName,
    });
    if (plyReport.data && plyReport.data.topHands) {
      let gameNumbers = [];
      plyReport.data.topHands.topWonHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })
      plyReport.data.topHands.topLostHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })

      const handInfoList = yield call(getHandInfoList, {
        gameType: action.data.gameType,
        accountName: localStorage.getItem("accountName"),
        gameNumbers
      })
      // set star status
      if (handInfoList.data && handInfoList.data.length > 0) {
        plyReport.data.topHands.topWonHands = plyReport.data.topHands.topWonHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
        plyReport.data.topHands.topLostHands = plyReport.data.topHands.topLostHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
      }
    }
    yield all([
      put(actions.setGameType(action.data.gameType)),
      put(actions.setReportCardSetting([repoSetting1, repoSetting2, repoSetting3, repoSetting4])),
      put(actions.setSingleReportCardDeatils(plyReport.data)),
      put(actions.setLevelInfo([{ medalDetails: response1.data }, { starDetails: response2.data }]))
      // action.data.gameType === "cash" && Object.keys(response3.data).length > 0 && put(actions.setMissions(response3.data))
    ]);
    yield put(actions.setLoading({ loading: false, isPromotional: true }));
    const promotionalContentResponse = yield call(getPromotionalContent, { score: plyReport.data.summaryInfo[0].points });
    yield put(actions.setPromotionalContent(promotionalContentResponse.data));
    yield put(actions.setLoading({ loading: false, isPromotional: false }));
  } catch (err) {
    yield put(actions.setLoading({ loading: false, isPromotional: false }));
    throw new Error(err);
  }
}

export function* getSingleReportCardsDetailsSaga(action) {
  try {
    let playerReportCard = yield select(selectors.playerReportCard);
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    let SB = "All";
    let BB = "All";
    if (action.data.hitRange === "Today") {
      if (action.data.hitLevel && action.data.hitLevel !== "All Level") {
        [SB, BB] = action.data.hitLevel.split("/");
      }
    }
    action.data["language"] = localStorage.getItem("new_language") || "en";
    let gameDateInfo = moment().format("DD/MM/YYYY");
    const [response, response1] = yield all([
      call(getReportCardDeatils, {
        ...action.data,
        key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${action.data.gameType}:${action.data.hitType}:${SB}:${BB}`
      })
      // localStorage.getItem("userRole").indexOf("PLAYER") != -1
      //   ? call(getMissions, { accountName: action.data.accountName, userType: localStorage.getItem("loggedInType") })
      // : { data: {} }
    ]);
    const [repoSetting1, repoSetting2, repoSetting3, repoSetting4] = yield all([
      setReportSettingData(response.data),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != response.data.gameType)[0]),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != response.data.gameType)[1]),
      setReportSettingData(playerReportCard.reportCardSetting.filter(reportSetting => reportSetting.gameType != response.data.gameType)[2]),
    ]);

    saveActivity({
      hit_page: `${response.data.gameType}ReportCard`,
      hit_type: "ReportCardDisplay",
      hit_attribute1:
        response.data.hitRange === "Select"
          ? "PlayerDetails:" + response.data.hands
          : response.data.hitRange,
      hit_attribute2: response.data.hitType,
      hit_attribute3: response.data.hitLevel,
      hit_attribute4: response.data.summaryInfo[0].medal
        ? response.data.summaryInfo[0].medal
        : "",
      hit_attribute5: response.data.playerName,
    });
    if (response.data && response.data.topHands) {
      let gameNumbers = [];
      response.data.topHands.topWonHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })
      response.data.topHands.topLostHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })

      const handInfoList = yield call(getHandInfoList, {
        gameType: action.data.gameType,
        accountName: localStorage.getItem("accountName"),
        gameNumbers
      })
      // set star status
      if (handInfoList.data && handInfoList.data.length > 0) {
        response.data.topHands.topWonHands = response.data.topHands.topWonHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
        response.data.topHands.topLostHands = response.data.topHands.topLostHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
      }
    }
    yield all([
      put(actions.setReportCardSetting([repoSetting1, repoSetting2, repoSetting3,repoSetting4])),
      put(actions.setSingleReportCardDeatils(response.data))
      // action.data.gameType === "cash" &&Object.keys(response1.data).length > 0 &&put(actions.setMissions(response1.data))
    ]);
    yield put(actions.setLoading({ loading: false, isPromotional: true }));
    const promotionalContentResponse = yield call(getPromotionalContent, {score: response.data.summaryInfo[0].points});
    yield put(actions.setPromotionalContent(promotionalContentResponse.data));
    yield put(actions.setLoading({ loading: false, isPromotional: false }));
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
}
export function* getMyStatisticsDetailsSaga(action) {
  try {
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    let SB = "All";
    let BB = "All";
    if(action.data.gameType === "spin"){
      action.data.hitType = "3 max"
    }
    if (action.data.hitRange === "Today") {
      if (action.data.hitLevel && action.data.hitLevel !== "All Level") {
        [SB, BB] = action.data.hitLevel.split("/");
      }
    }
    let gameDateInfo = moment().format("DD/MM/YYYY");
    const [response] = yield all([
      // call(getReportCardDeatils, { ...action.data,
      //     key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${action.data.gameType}:${action.data.hitType}:${SB}:${BB}`
      // })
      call(getMyStatistics, {
        ...action.data,
        key: `${gameDateInfo}:${localStorage.getItem("accountName")}:${
          action.data.gameType
          }:${action.data.hitType}:${SB}:${BB}`
      })
    ]);
    saveActivity({
      hit_page: `MyStatistics`,
      hit_type: "DisplayStatistics",
      hit_attribute1: action.data.hitRange,
      hit_attribute2: `${action.data.gameSubType} | ${action.data.hitLevel}`,
      hit_attribute3: `${(response.data &&
        response.data.myStatistics &&
        response.data.myStatistics.hands) ||
        0}`,
      hit_attribute4: `${(response.data &&
        response.data.myStatistics &&
        response.data.myStatistics.profit) ||
        0}`,
      hit_attribute5: `${(response.data &&
        response.data.myStatistics &&
        response.data.myStatistics.rake) ||
        0}`
    });

    if(response.data && response.data.topHands) {
      let gameNumbers = [];
      response.data.topHands.topWonHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })
      response.data.topHands.topLostHands.map(hand => {
        gameNumbers.push(hand.gameNo)
      })
  
      const handInfoList = yield call(getHandInfoList, {
        gameType: action.data.gameType,
        accountName: localStorage.getItem("accountName"),
        gameNumbers
      })
      // set star status
      if (handInfoList.data && handInfoList.data.length > 0) {
        response.data.topHands.topWonHands = response.data.topHands.topWonHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
        response.data.topHands.topLostHands = response.data.topHands.topLostHands.map(hand => {
          hand.staredHand = false;
          handInfoList.data.map(handInfo => {
            if (handInfo.gameNo.toString() === hand.gameNo.toString()) {
              hand.staredHand = handInfo.staredHand;
            }
          })
          return hand;
        })
      }
    }
    yield all([put(actions.setMyStatisticsDetails({ ...response.data }))]);

    yield put(actions.setLoading({ loading: false, isPromotional: false }));
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
}
export function* getPlayerLevels(action) {
  try {
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    const [response] = yield all([
      call(getPlayerLevelsSaga, { ...action.data })
    ]);

    yield all([put(actions.setPlayerLevels({ ...response.data }))]);

    yield put(actions.setLoading({ loading: false, isPromotional: false }));
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
}
export function* getPlayerGameSubTypes(action) {
  try {
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    const [response] = yield all([
      call(getPlayerGameSubTypesSaga, { ...action.data })
    ]);
    yield all([put(actions.setPlayerGameSubTypes(response.data))]);

    yield put(actions.setLoading({ loading: false, isPromotional: false }));
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
}
export function* getPlayerHitTypes(action) {
  try {
    yield put(actions.setLoading({ loading: true, isPromotional: false }));
    const [response] = yield all([
      call(getPlayerHitTypesSaga, { ...action.data })
    ]);
    yield all([put(actions.setPlayerHitTypes(response.data))]);

    // yield put(actions.setLoading({loading:false,isPromotional:false}))
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
}

export function* getMissionsSaga(action) {
  try {
    yield put(actions.setLoading({ loading: true }));
    const response = yield call(getMissions, action.data);
    yield put(actions.setMissions(response.data));
    yield put(actions.setLoading({ loading: false }));
  } catch (err) {
    yield put(actions.setLoading({ loading: false }));
    throw new Error(err);
  }
}



/** WEBPACK FOOTER **
 ** ./src/store/sagas/multipleReportCards.js
 **/